<template>
  <computed :is="getType(type)" :class="['micad_mainHeading_' + type]">{{title}}</computed>
</template>

<script>
export default {
  name: 'Flags',
  props: {
    type: String,
    title: String
  },
  methods: {
   getType(type) {
      if(type == "mainHeading") {
          return "h1";
      }
      if(type == "heading") {
        return "h2";
      } else{
        return "h3";
      }
    }
  }
};
</script>